import React from 'react'
import { useSelector } from 'react-redux'
import { getProgramDetailsCommonProps } from '@screens/Marketplace/components/ProgramDetails/utils.ts'
import { ProgramDetailsContent } from '@screens/Marketplace/components/ProgramDetails/ProgramDetailsContent.tsx'
import { ProgramDetailsHeader } from '@screens/Marketplace/components/ProgramDetails/ProgramDetailsHeader.tsx'
import { uhcDeepLinkSelector } from '@selectors/app.ts'
import { useProducts, useSubscriptionFromRoute } from '../../utils/hooks'

export const ProgramDetails = () => {
  const { subscription } = useSubscriptionFromRoute()
  const { activeSubscriptions } = useProducts()
  const uhcDeepLinks = useSelector(uhcDeepLinkSelector)

  if (!subscription) {
    return null
  }

  const programDetailsCommonProps = getProgramDetailsCommonProps(
    subscription,
    uhcDeepLinks,
    activeSubscriptions.some((s) => s.primaryProduct.uhc),
  )

  return (
    <ProgramDetailsHeader>
      <ProgramDetailsContent subscription={subscription} {...programDetailsCommonProps} />
    </ProgramDetailsHeader>
  )
}
